import React from 'react';
import Header from '../../shared/TableHeader';

export default ({
  ...props
}) => {
  return (
    <Header
      columns={['Employee', 'Clock In', 'Clock In Location', 'Clock Out', 'Clock Out Location']}
    />
  );
};
